import { controls } from "../../controls";

const rp813 = {
  label: "Share Certificate Printing",
  pageLabel: "Share Certificate Printing",
  starting: true,
  url: "rp813",

  pageType: "history",
  filter: [


    ...controls.displayText({ tab: "filter", label: "Transaction Type", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "trn_type", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Issue",
        value: "issue"
      },
      {
        label: "By Transfer (Issue)",
        value: "by_transfer"
      },
      {
        label: "To Transfer",
        value: "to_transfer"
      },
      {
        label: "Withdraw",
        value: "withdraw"
      },
      {
        label: "Cancel",
        value: "cancel"
      }]
    }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4 " }),

    ...controls.checkBox({ tab: "filter", label: "Regional Name", name: "regional_name", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", star: true, label: "Date From-To", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "from_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", star: true, label: "", width: "col-sm-0 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "to_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6 " }),

    ...controls.displayText({ tab: "filter", star: true, label: "Member Type", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "member_type", isRequired: true, width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Regular",
        value: "regular"
      },
      {
        label: "Associated",
        value: "associated"
      },
      {
        label: "Nominal (B-Class)",
        value: "nominal"
      }]
    }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8 " }),

    ...controls.displayText({ tab: "filter", label: "Member Number From-To", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "member_number_from", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-0" }),
    ...controls.numberOnly({ tab: "filter", name: "member_number_to", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6 " }),

    ...controls.displayText({ tab: "filter", label: "Amount From-To", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "amount_from", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-0" }),
    ...controls.numberOnly({ tab: "filter", name: "amount_to", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6 " }),

    ...controls.displayText({ tab: "filter", label: "Member from Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6 " }),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-2" }),
    ...controls.perPage({ tab: 'filter' }),

    ...controls.checkBox({ tab: "filter", label: "Member Summary", name: "member_summary", width: "col-sm-2" }),

  ],

  form: [],

  history: {
    perPage: 10,
    reportHeader: "Share Certificate Printing",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [

      {
        Header: "Sr",
        type: "autoinc",
        accessor: "srno",
        width: 30
      },

      {
        Header: "Date",
        accessor: "date"

      },

      {
        Header: "Member No",
        accessor: "member_no",

      },

      {
        Header: "CIN",
        accessor: "cin",

      },


      {
        Header: "Member Name",
        accessor: "member_name",

      },

      {
        Header: "Type",
        accessor: "type",

      },

      {
        Header: "Credit Nos",
        accessor: "credit_nos",

      },


      {
        Header: "Credit ",
        accessor: "credit",
        type: "currency"
      },


      {
        Header: "Debit",
        accessor: "debit",
        type: "currency"
      },
      {
        Header: "Debit Nos",
        accessor: "debit_nos",
        type: "currency"
      },

      {
        Header: "Certificate No",
        accessor: "certificate_no",

      },

      {
        Header: "Certificate Date",
        accessor: "certificate_date",

      },
      {
        Header: "From No",
        accessor: "from_no",

      },
      {
        Header: "To No",
        accessor: "to_no",

      },

      {
        Header: "Trf TO/From",
        accessor: "trf_to/from",

      },

      {
        Header: "Trf TO/From Name",
        accessor: "trf_to/from_name",

      },



    ]
  }
};

export default rp813;